export function formatPhoneNumber(phone: string): string {
  phone = phone.replace(/\s/g, '');
  if (phone.length < 8) {
    return phone;
  }

  let prefix = '';
  let number = '';
  if (phone.startsWith('+')) {
    prefix = phone.substr(0, 3);
    number = phone.substr(3);
  }
  if (number.length < 8) {
    return `${prefix} ${number}`;
  }

  if (number.length === 8) {
    return [
      prefix,
      number.substr(0, 3),
      number.substr(3, 2),
      number.substr(5, 3),
    ].join(' ');
  } else if (number.length === 9) {
    return [
      prefix,
      number.substr(0, 2),
      number.substr(2, 3),
      number.substr(5, 2),
      number.substr(7, 2),
    ].join(' ');
  } else {
    return [prefix, number].join(' ');
  }
}
